/**
 * 通知範本 API Service
 */

import apiClient from '../axios.js';

export const notificationTemplateService = {
  /**
   * 查詢通知範本列表
   */
  async list(params = {}) {
    const response = await apiClient.get('/admin/notification-templates', { params });
    return response;
  },

  /**
   * 查詢通知範本詳情
   */
  async getById(id) {
    const response = await apiClient.get(`/admin/notification-templates/${id}`);
    return response;
  },

  /**
   * 新增通知範本
   */
  async create(data) {
    const response = await apiClient.post('/admin/notification-templates', data);
    return response;
  },

  /**
   * 更新通知範本
   */
  async update(id, data) {
    const response = await apiClient.put(`/admin/notification-templates/${id}`, data);
    return response;
  },

  /**
   * 刪除通知範本
   */
  async remove(id) {
    const response = await apiClient.delete(`/admin/notification-templates/${id}`);
    return response;
  }
};
